import { render } from "./WalletSettingsModal.vue?vue&type=template&id=93b2204e&ts=true"
import script from "./WalletSettingsModal.vue?vue&type=script&lang=ts"
export * from "./WalletSettingsModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/bisite/hyperlender/express-server/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__